import { createFileRoute, Link, Outlet, notFound, useMatches } from "@tanstack/react-router";
import { findBnLocation, type BnLocation } from "@/content/bn/locations";
import { BnCityView } from "@/components/bn-city/BnCityHub";
import { bnCityHead } from "@/lib/bn-city-head";

export const Route = createFileRoute("/bn/seo-services/$location")({
  loader: ({ params }): { loc: BnLocation } => {
    const loc = findBnLocation(params.location);
    if (!loc) throw notFound();
    return { loc };
  },
  head: ({ loaderData, match, matches }) => {
    // Also the layout parent of /bn/seo-services/$location/$service — only the
    // leaf match may emit canonical/hreflang, otherwise pages ship two sets.
    const isLeaf = matches[matches.length - 1]?.routeId === match.routeId;
    if (!isLeaf) return {};
    return bnCityHead(loaderData?.loc);
  },
  component: BnLocationPage,
  notFoundComponent: () => (
    <div className="container-x py-32 text-center">
      <h1 className="font-display text-3xl">শহরটি খুঁজে পাওয়া যায়নি</h1>
      <Link to="/bn/services" className="mt-6 inline-flex text-primary">সেবাসমূহে ফিরে যান</Link>
    </div>
  ),
});

function BnLocationPage() {
  const { loc } = Route.useLoaderData();
  const matches = useMatches();
  // Layout parent of /bn/seo-services/$location/$service — defer to the child
  // match when one is active.
  const isLeaf = matches[matches.length - 1]?.routeId === "/bn/seo-services/$location";
  if (!isLeaf) return <Outlet />;
  return <BnCityView loc={loc} />;
}
